const experience = [
  {
    position: "Backend Development Intern",
    company: "AppComm",
    location: "Tegelen, Venlo",
    duration: "September 2024 - January 2025",
    description: "Development a in-house hour registration system, integrating GitLab and Simplicate for seamless time tracking and billing. Additionally, developed a high-performance data transformation tool to convert large-scale CSV datasets into XML files, optimizing system compatibility and significantly reducing processing time.",
    achievements: [
      "Developed an hour registration system that integrates with GitLab and Simplicate, streamlining project time tracking and billing",
      "Implemented Test-Driven Development (TDD) in Laravel to ensure code quality and maintainability",
      "Designed and built a Python-based CSV-to-XML conversion tool, reducing processing time from several hours to under 30 seconds for millions of records",
      "Optimized data exchange between incompatible systems, enhancing automation and workflow efficiency"
    ],
    technologies: ["Laravel", "Python", "GitLab REST API", "Simplicate REST API"]
  },
  {
    position: "Full Stack Development Intern",
    company: "IBI² - Institute for Sustainable Transitions & Biomimicry Innovations",
    location: "Venlo, Netherlands",
    duration: "February 2024 - June 2024",
    description: "Developed an enhanced version of IBI²'s QuickScan tool, which helps companies assess their alignment with the United Nations Sustainable Development Goals (SDGs). The tool enables businesses to generate detailed sustainability reports, track improvements over time, and receive recommendations based on EU sustainability standards. The project involved full-stack development, from UI/UX design to backend implementation, including authentication, database management, and report generation.",
    achievements: [
      "Designed and implemented a full-stack application to automate sustainability assessments for businesses",
      "Developed features for generating, reviewing, and printing SDG compliance reports, improving efficiency for IBI² consultants",
      "Enabled historical data tracking, allowing companies to measure their progress on sustainability goals over time",
      "Gained hands-on experience in building secure authentication, database management, and reporting functionalities"
    ],
    technologies: ["PHP", "MySQL"]
  }
];

export default experience;